"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: auto;

  font-weight: 400;
  color: ${({ theme }) => theme.palette.common.black};

  .text-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};

    &-title {
      font-size: 1rem;
      line-height: 1.625rem;
      text-align: center;
    }
  }

  .icon svg {
    width: unset;
    height: unset;
  }
`;
